import { RichTextAdvancedRender } from '../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../ui/form/ConfigFormItem.tsx';
import { DivInputStyle } from '../../../../ui/form/DivInputStyle.tsx';
import { ComputeExpressionPreview } from '../../../expressions/compute/preview/ComputeExpressionPreview.tsx';
import { type IWidgetComponentProps } from '../../IWidgetType.ts';
import { getWidgetProps } from '../inputs/common/util/getWidgetProps.ts';
import { type IComputedExpressionWidget } from './IComputedWidget.ts';

type ICommonComputedWidgetPreviewProps =
  IWidgetComponentProps<IComputedExpressionWidget>;

export function CommonComputedWidgetPreview(
  props: ICommonComputedWidgetPreviewProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name="string"
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <DivInputStyle>
        <ComputeExpressionPreview expression={widget.expression} />
      </DivInputStyle>
    </ConfigFormItem>
  );
}
